export const isNullOrUndefined = (value) =>
  value === null || value === undefined;

export const isString = (value) =>
  typeof value === "string" || value instanceof String;

/*
 * Check if the value is a number.
 * A number can be a decimal, a number, or a bigint.
 * @param {any} value
 * @returns {boolean}
 */
export const isNumber = (value) =>
  value?.isDecimal?.() ||
  value?.toNumber?.() ||
  value?.isZero?.() ||
  typeof value === "number" ||
  typeof value === "bigint";

export const isBoolean = (value) => typeof value === "boolean";

/**
 * Converts an object with BigInt values to JSON-serializable format for API responses.
 * BigInts become strings, preserving precision but losing type information.
 * Use this before calling res.json() when your data might contain BigInt values.
 *
 * @param {any} obj - Object to convert
 * @returns {any} - Object with BigInts converted to strings
 */
export const prepareBigIntForJson = (obj) => {
  return JSON.parse(
    JSON.stringify(obj, (_, val) =>
      typeof val === "bigint" ? val.toString() : val
    )
  );
};
